// extracted by mini-css-extract-plugin
export default {"badge-button":"_4BMeP","badgeButton":"_4BMeP","badge":"_299-K"};